import { AdsDetailApi } from '../../api'
import { setRegistrationPremiumClasses } from '../setRegistrationPremiumClasses'

export const fetchRegistrationPremiumClasses = () => async dispatch => {
  const api = new AdsDetailApi()
  const registrationPremiumClasses = await api.getRegistrationPremiumClasses()
  dispatch(setRegistrationPremiumClasses(registrationPremiumClasses))
}
